var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCloud = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "210px",
    height: "130px",
    viewBox: "0 0 210 130",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "33C2D7C9-E617-4970-8FE4-E502333A4C19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MVP_CompanyDESKTOP",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Error-Page",
    transform: "translate(-375.000000, -243.000000)",
    fill: "#E0E0E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M568.49,308.096528 C575.33,289.847764 558.28,270.964684 534.5,271.371296 C509.56,227.229454 429.78,236.963755 420.74,284.195851 C394.4,287.782173 375,306.193582 375,328.272636 C375,352.937744 399.68,373 430,373 L540,373 C564.82,373 585,356.589123 585,336.404884 C585,325.39382 578.9,315.025204 568.49,308.096528",
    id: "Fill-3659"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCloud);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cloud.f283ee30a4314210a6d224a2d71b12f4.svg";